import { render, staticRenderFns } from "./VtContent.vue?vue&type=template&id=55c46da4&"
import script from "./VtContent.vue?vue&type=script&lang=js&"
export * from "./VtContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports